import React, { useState } from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import CalendyForm from "./CalendyForm";
import Button from "@material-ui/core/Button";
import { textBoxConstants, testimonials, FAQs } from "../../constants";
import { SlidingCarousel } from "components";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const col1 = css`
  text-align: center;
`;

const imageContainer = css`
  position: relative;
  z-index: 1;

  ::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 0;
    width: 250px;
    border-radius: 8px;
    height: 225px;
    background: #465362;
    z-index: -1;
  }
  @media only screen and (min-width: 375px) {
    ::before {
      content: "";
      position: absolute;
      left: 15px;
      top: 0;
      width: 250px;
      border-radius: 8px;
      height: 225px;
      background: #465362;
      z-index: -1;
    }
  }

  @media only screen and (min-width: 500px) {
    ::before {
      content: "";
      position: absolute;
      left: 37px;
      top: 0;
      width: 250px;
      border-radius: 8px;
      height: 225px;
      background: #465362;
      z-index: -1;
    }
  }
  @media only screen and (min-width: 768px) {
    ::before {
      content: "";
      position: absolute;
      left: -25px;
      top: 0;
      width: 330px;
      border-radius: 8px;
      height: 300px;
      background: #465362;
      z-index: -1;
    }
  }
  @media only screen and (min-width: 768px) {
    ::before {
      content: "";
      position: absolute;
      left: -25px;
      top: 0;
      width: 330px;
      border-radius: 8px;
      height: 300px;
      background: #465362;
      z-index: -1;
    }
  }
  @media only screen and (min-width: 900px) {
    ::before {
      content: "";
      position: absolute;
      left: -25px;
      top: 0;
      width: 420px;
      border-radius: 8px;
      height: 300px;
      background: #465362;
      z-index: -1;
    }
  }
  @media only screen and (min-width: 1200px) {
    ::before {
      content: "";
      position: absolute;
      left: -25px;
      top: 0;
      width: 450px;
      border-radius: 8px;
      height: 300px;
      background: #465362;
      z-index: -1;
    }
  }
`;

const contactImage = css`
  width: 275px;
  border-radius: 8px;
  margin-top: 25px;

  box-shadow: 0px 0px 30px rgb(0 0 0 / 10%);
  @media only screen and (min-width: 500px) {
    width: 400px;
  }

  @media only screen and (min-width: 768px) {
    width: 400px;
  }
  @media only screen and (min-width: 900px) {
    width: 480px;
  }
  @media only screen and (min-width: 1200px) {
    width: 510px;
  }
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function MarketingLandingPage({ history }) {
  const [scrollToScheduling, setScrollToScheduling] = useState(false);

  const scrollTo = (ref) => {
    if (ref && scrollToScheduling) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setScrollToScheduling(false);
  };

  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "calc(100vh - 70px)",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div
            className={styles.row}
            style={{
              padding: "0px",
            }}
          >
            <div className={styles.maxWidthWrapper}>
              <div
                className={styles.col + " " + styles.col3}
                style={{ marginBottom: "50px" }}
              >
                <div className={imageContainer}>
                  <img
                    className={contactImage}
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/MyMysMeals.png"
                    alt="marketing-img"
                  ></img>
                </div>
              </div>
              <div
                className={styles.col + " " + styles.col1_4_pic}
                style={{ padding: "0px" }}
              >
                <CalendyForm
                  text={
                    "We help small businesses like Shamaya's build a mobile app and website."
                  }
                />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1_4}>
                <styles.H1MainHeader>
                  Personalized <br />
                  mobile app &amp; website in{" "}
                  <span style={{ color: "#89d2d3" }}>30 minutes.</span>
                </styles.H1MainHeader>
                <styles.P style={{ fontSize: "18px" }}>
                  Using our no code mobile app builder, you can build, customize
                  and launch a mobile app and website to the{" "}
                  <span
                    style={{
                      color: "#89d2d3",
                      textDecoration: "underline",
                      // cursor: "pointer",
                    }}
                    // onClick={() => setScrollToMarketPlace(true)}
                  >
                    Mobile360 Marketplace{" "}
                  </span>
                  in just 30 minutes. No technical or design skill required, we
                  promise. 
                  <br />
                  <br />
                  Streamline your small business and reengage customers with
                  Fortune 500 technology. Affordably.
                </styles.P>
                <Button
                  onClick={() => {
                    setScrollToScheduling(true);
                  }}
                  variant="contained"
                  color="secondary"
                  type="submit"
                  size="lg"
                  style={{
                    textTransform: "none",
                    width: "auto",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  Schedule a Free Demo
                </Button>
              </div>
              <div className={styles.col + " " + styles.col3pic}>
                {/* <LazyLoadImage
                src={
                  "https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                } // use normal <img> attributes as props
                wrapperClassName={styles.heroImage}
                alt="hero-image"
                effect="opacity"
                delayTime={500}
              /> */}
                {/* <ImageLoad
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                placeholder=""
                className={styles.heroImage}
                alt="Decription"
              /> */}
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/Hero Image.svg"
                  className={styles.heroImage}
                  alt="hero-image"
                ></img>
              </div>
            </div>
          </div>
          <div
            className={styles.row}
            style={{
              backgroundImage: "linear-gradient(135deg,#89d2d3,#b1dada)",
              marginBottom: "0px",
            }}
          >
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2 style={{ width: "100%" }}>
                  The Mobile360 App Marketplace
                </styles.H2>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "40px",
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                    }}
                  >
                    {testimonials.map((t, idx) => {
                      // console.log("got testimonials: " + testimonials.length);
                      // console.log(t.name + ": " + idx);
                      if (idx > 3)
                        return (
                          <div key={t.name}>
                            <div className={styles.imageCropper}>
                              <img
                                className={styles.logoStyle}
                                src={t.logo}
                                alt={t.name}
                              ></img>
                            </div>
                          </div>
                        );
                    })}
                  </div>
                  <img
                    className={styles.appsImage}
                    src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/mobileApps.svg"
                  />
                  <div
                    style={{
                      display: "inline-block",
                    }}
                  >
                    {testimonials.map((t, idx) => {
                      // console.log("got testimonials: " + testimonials.length);
                      // console.log(t.name + ": " + idx);
                      if (idx < 3)
                        return (
                          <div key={t.name}>
                            <div className={styles.imageCropper}>
                              <img
                                className={styles.logoStyle}
                                src={t.logo}
                                alt={t.name}
                              ></img>
                            </div>
                          </div>
                        );
                    })}
                  </div>
                </div>
                <styles.P style={{ marginBottom: "30px", fontSize: "18px" }}>
                  All Your Favorite Apps In One Place!
                </styles.P>
                <styles.P>
                  Support all your favorite local businesses right on the
                  Mobile360 marketplace. Click{" "}
                  <a href={"/marketplace"} style={{ textDecoration: "none" }}>
                    here
                  </a>{" "}
                  to discover them all!
                </styles.P>
                <styles.P
                  style={{
                    marginBottom: "30px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  Download the Marketplace App
                </styles.P>
                <div style={{ marginTop: "2em", marginBottom: "1em" }}>
                  <div className={styles.bouncingArrow}>
                    <ArrowDownwardIcon fontSize="large" />
                  </div>
                </div>
                <div
                  className={styles.flexyRowCol}
                  style={{ marginBottom: "30px" }}
                >
                  <a
                    href="https://apps.apple.com/us/app/mobile360/id1466921046"
                    target="_blank"
                  >
                    <img
                      src="https://mobile360-assets.s3.us-east-2.amazonaws.com/apple-store.svg"
                      // style={{ height: "75px" }}
                      alt="Download on the app store logo png"
                      className={styles.appleStore}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.mobile360.android"
                    target="_blank"
                  >
                    <img
                      src="https://mobile360-assets.s3.us-east-2.amazonaws.com/google-play-store.svg"
                      // width="257"
                      // height="112"
                      alt="google play itunes png logo"
                      className={styles.googlePlayStore}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.row + " " + styles.offwhite}
            style={{ marginBottom: "0px", justifyContent: "center" }}
          >
            {" "}
            <styles.H2
              style={{
                textAlign: "center",
                marginBottom: "0px",
                marginTop: "60px",
              }}
            >
              How It <span className={styles.styledUnderline}>Works</span>
            </styles.H2>
          </div>
          <div
            className={styles.row + " " + styles.offwhite}
            style={{
              marginBottom: "0px",
              padding: "30px 10px",
            }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Add Screens Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/1.png"
                  className={styles.step}
                  alt="step-1"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Build Your App &amp; Website
                </styles.ColoredH5>
                <styles.P>
                  We’ve made the simplest no-code app and website builder
                  possible. No coding. No logic blocks. No difficult design
                  decisions.
                  <br /> <br />
                  Build your app and website in just 30 minutes. It’s that
                  simple.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/app_builder_overview.png"
                  className={styles.addScreens}
                  alt="add-screens"
                ></img>
              </div>
            </div>
          </div>
          <div
            className={styles.row + " " + styles.offwhite}
            style={{ marginBottom: "0px", padding: "30px 10px" }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Publish Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3. The offwite style above refers to the light green blue background.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/2.png"
                  className={styles.step}
                  alt="step-2"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Launch Your App and Website to the Mobile360 Marketplace
                </styles.ColoredH5>
                <styles.P>
                  All apps created on Mobile360 get hosted in the core Mobile360
                  app, known as the Mobile360 marketplace.
                  <br /> <br />
                  The marketplace app allows us to manage the nuances,
                  maintenance 🛠, design 🎨, and expensive costs 💰 of having a
                  mobile app, while you leverage all the benefits of having one.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/marketplace_overview.png"
                  className={styles.addScreens}
                  alt="publish-app"
                ></img>
              </div>
            </div>
          </div>
          <div
            className={styles.row + " " + styles.offwhite}
            style={{ marginBottom: "0px", padding: "30px 10px" }}
          >
            {/************************************************************************************************
             *************************************************************************************************
             * Business Grow Row
             * 3 column Row that includes the number as an img src from s3, the text and finally the img src
             * from s3.
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col_ss}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/3.png"
                  className={styles.step}
                  alt="step-3"
                ></img>
              </div>
              <div className={styles.col + " " + styles.col_xs}>
                <styles.ColoredH5>
                  Engage Customers and Grow 🚀
                </styles.ColoredH5>
                <styles.P>
                  Blast your app download link and QR code to your customers. In
                  one click, we take them directly to your app or website within
                  Mobile360.
                  <br />
                  <br />
                  Reengage them with push notifications, special offers,
                  exclusive content, and more.
                </styles.P>
              </div>
              <div className={styles.col + " " + styles.col1_4_pic}>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/download_link_code.png"
                  // src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/marketplace_download_overview.png"
                  className={styles.addScreens}
                  alt="watch-it-grow"
                ></img>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "30px",
                width: "100%",
              }}
            >
              <Button
                onClick={() => {
                  setScrollToScheduling(true);
                }}
                variant="contained"
                color="secondary"
                type="submit"
                size="lg"
                style={{
                  textTransform: "none",
                  width: "auto",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Schedule a Free Demo
              </Button>
            </div>
          </div>
          <div
            style={{ width: "100%", paddingBottom: "30px" }}
            className={styles.offwhite}
          >
            <div
              style={{
                marginBottom: "30px",
                maxWidth: "1200px",
                margin: "auto",
              }}
            >
              <SlidingCarousel></SlidingCarousel>
            </div>
          </div>
          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>
                <a ref={scrollTo}></a>

                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default MarketingLandingPage;
